import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromPortalConfig from './+state/portal-config.reducer';
import { PortalConfigEffects } from './+state/portal-config.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromPortalConfig.PORTAL_CONFIG_FEATURE_KEY,
      fromPortalConfig.portalConfigReducer
    ),
    EffectsModule.forFeature([PortalConfigEffects]),
  ],
})
export class SharedDataAccessPortalConfigModule {}
